var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntelli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2500,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "99.799%",
    y2: "50%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B07B58",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577BAE",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E7CE5",
    offset: "91%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".345%",
    y1: "34.54%",
    x2: "121.182%",
    y2: "77.619%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB7A3E",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E7B6A",
    offset: "15%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757B91",
    offset: "24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537BB1",
    offset: "33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387CCC",
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#237CE0",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147CEF",
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7CF7",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.169%",
    y1: "97.749%",
    x2: "30.106%",
    y2: "-6.624%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB417E",
    offset: "8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E4E9B",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755BB4",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5365CA",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#386DDB",
    offset: "44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2374E9",
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1478F3",
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B7BF8",
    offset: "79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "20%",
    y1: "24.087%",
    x2: "103.422%",
    y2: "132.676%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63462",
    offset: "4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3A71",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C24383",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD4A91",
    offset: "29%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#755BB4",
    offset: "55%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D76ED",
    offset: "92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFA",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M64.8 199.6l-62-48.8 30.8-57.2L122 128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M256 68.4l-4.8 148-98.4 39.6-59.2-38.4L180 128l-37.6-83.2 34-40.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M256 68.4l-78 92-35.6-115.6 34-40.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M123.2 212.4L20.8 249.6 37.2 192l21.2-71.2L0 101.2 37.2 0l80 9.6 79.2 90.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h160v160H48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2 178h60v10h-60v-10zM106 80.8v-12H73.2v12h9.2v42h-9.2v12.4H106v-12.4h-9.2v-42h9.2zm32 55.2a26.84 26.84 0 0 1-13.2-2.8 31.48 31.48 0 0 1-8.8-7.2l9.2-10.4a29.88 29.88 0 0 0 5.6 4.8 11.72 11.72 0 0 0 6.4 1.6 7.44 7.44 0 0 0 6.4-2.8 11.72 11.72 0 0 0 2.4-8.4V68h14.8v43.2a27.08 27.08 0 0 1-1.6 10.4 20 20 0 0 1-5.6 8.8A28.6 28.6 0 0 1 138 136z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelli);
export default __webpack_public_path__ + "static/media/intelli.ff854dd0998b7121a3c23938a3836682.svg";
export { ForwardRef as ReactComponent };